export default __webpack_public_path__ + "static/media/img2.646e0ad8.png";